export const FEEDBACK_UI_DELAY = 500;
export const REQUEST = {
  DEFAULT: 0,
  SENDING: 1,
  SENT: 2
};
